import Keycloak from "keycloak-js";

const runtimeEnv = window.__ENV || {};

const keycloak = new Keycloak({
  url: runtimeEnv.REACT_APP_KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_URL || "http://localhost:8080",
  realm: runtimeEnv.REACT_APP_KEYCLOAK_REALM || process.env.REACT_APP_KEYCLOAK_REALM || "marketplace",
  clientId: runtimeEnv.REACT_APP_KEYCLOAK_CLIENT_ID || process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "marketplace-web",
});

export default keycloak;
